import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76654a12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "project-stage-card-header" }
const _hoisted_4 = { class: "project-stage-card-content" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex",
  style: {"margin-top":".75rem","margin-bottom":"10px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"margin-right":"2px"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line",
  style: {"margin-left":"2px"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass(["project-stage-card", { active: _ctx.active, inactive: _ctx.inactive }]),
    style: _normalizeStyle({ zIndex: 998 - _ctx.index })
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "header", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "content", {}, undefined, true)
          ])
        ])
      ]),
      (_ctx.arrow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "style"]))
}